import { render, staticRenderFns } from "./Clave.vue?vue&type=template&id=09779abe"
import script from "./Clave.vue?vue&type=script&lang=js"
export * from "./Clave.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\signar-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09779abe')) {
      api.createRecord('09779abe', component.options)
    } else {
      api.reload('09779abe', component.options)
    }
    module.hot.accept("./Clave.vue?vue&type=template&id=09779abe", function () {
      api.rerender('09779abe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/perfil/Clave.vue"
export default component.exports